import { createAction } from 'redux-act';

import * as userInterests from '../../core/userInterests';

export const fetchUserInterests = createAction(
  'get all userInterests',
);
export const fetchUserInterestsSuccess = createAction(
  'get all userInterests success',
);
export const fetchUserInterestsFail = createAction(
  'get all userInterests fail',
  (error) => error
);

export const openUserInterestDetails = createAction(
  'open userInterest modal'
);
export const closeUserInterestDetails = createAction(
  'close userInterest modal'
);

export const fetchUserInterestDetails = createAction(
  'get userInterest details'
);
export const fetchUserInterestDetailsSuccess = createAction(
  'fetch userInterest details success'
);
export const fetchUserInterestDetailsFail = createAction(
  'fetch userInterest details fail'
);

export const openUserInterestApps = createAction(
  'open userInterest apps modal'
);
export const closeUserInterestApps = createAction(
  'close userInterest apps modal'
);

export const reducer = {
  [fetchUserInterests]: (state, payload) =>
    userInterests.fetchUserInterests(state, payload),
  [fetchUserInterestsSuccess]: (state, payload) =>
    userInterests.fetchUserInterestsSuccess(state, payload),

  [fetchUserInterestDetails]: (state, payload) =>
    userInterests.fetchUserInterestDetails(state, payload),
  [fetchUserInterestDetailsSuccess]: (state, payload) =>
    userInterests.fetchUserInterestDetailsSuccess(state, payload),

  [openUserInterestDetails]: (state, payload) =>
    userInterests.openUserInterestDetails(state, payload),
  [closeUserInterestDetails]: (state, payload) =>
    userInterests.closeUserInterestDetails(state, payload),

  [openUserInterestApps]: (state, payload) =>
    userInterests.openUserInterestApps(state, payload),
  [closeUserInterestApps]: (state, payload) =>
    userInterests.closeUserInterestApps(state, payload),
};



/** WEBPACK FOOTER **
 ** ./js/redux/modules/userInterests.module.js
 **/